module.exports = __webpack_public_path__ + "media/assets/icons/editWhite-586e20333eb50e32bc07ffa746361b1f.svg";